export enum NeedsInterpreterEnum {
  No = 0,
  Yes = 1,
  UnableToDetermine = 9
}

export const NeedsInterpreterOptions = [
{ id: 0, label: 'No' },
{ id: 1, label: 'Yes' },
{ id: 9, label: 'Unable to determine' }
];
